import {FORM_ERROR} from '@constants/messages';

export function renderFormErrorMessages() {
    return FORM_ERROR('MediaConnect origin entry points');
}
